import { runtimeUrls } from './env';

/**
 * Extracts the latest app download URL from an appcast XML string.
 */
export function parseReleaseFeedXml(xml: string): string {
  const parser = new DOMParser();
  const document = parser.parseFromString(xml, 'text/xml');
  const parserError = document.querySelector('parsererror');

  if (parserError) {
    throw new Error('Unable to parse update feed XML.');
  }

  const enclosure = document.documentElement.querySelector('channel item enclosure');
  const url = enclosure?.getAttribute('url') ?? '';

  if (url.length === 0) {
    throw new Error('Update feed did not include a download URL.');
  }

  return url;
}

/**
 * Fetches and parses the latest MeshOS app release feed.
 */
export async function parseReleaseFeed(
  fetcher: typeof fetch = fetch,
  feedUrl = runtimeUrls.appReleaseFeed
): Promise<string> {
  const response = await fetcher(feedUrl);

  if (!response.ok) {
    throw new Error(`Unable to load update feed, got HTTP response code ${response.status}`);
  }

  return parseReleaseFeedXml(await response.text());
}
